import { useState } from 'react';

import { Outlet } from 'react-router';

import Sidebar from '../../components/Globals/Sidebar/Sidebar';
import './AppLayout.scss';

const AppLayout = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <div className="app">
      <Sidebar collapsed={sidebarCollapsed} onToggle={() => setSidebarCollapsed((prev) => !prev)} />
      <main className="main">
        <div className="content">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AppLayout;
